import { useCallback, useEffect, useRef } from 'react';

/**
 * show browser default dialog on beforeunload event
 * link click is excluded (handled by useConfirmLinkNavigation)
 */
export const useConfirmBrowserNavigation = (shouldConfirm: boolean) => {
  const shouldSkipConfirmRef = useRef(false);

  useEffect(() => {
    if (!shouldConfirm) {
      return;
    }

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (shouldSkipConfirmRef.current) {
        shouldSkipConfirmRef.current = false;
        return;
      }

      e.preventDefault();
      e.returnValue = '';
      return '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [shouldConfirm]);

  const skipBrowserConfirm = useCallback(() => {
    shouldSkipConfirmRef.current = true;
  }, []);

  return { skipBrowserConfirm };
};
